export default {
  "upsert": "full",
  'entityName': 'disposed',
  // "title": "Site request",
  "pagination": {
    "itemsPerPage": 5,
    "page": 1,
    "sortBy": "id",
    "descending": true
  },
  "fields": [
    {
      "value": "protocol_id",
      "text": "Protocol",
      "type": "autocomplete",
      "table": {
        "sortable": true,
        filter: true
      },
      // filter: () => ({ status: 'ACTIVE' }),
      "title": "name",
      validators: ['required']
    },
    {
      "value": "_site_id1",
      reference: 'protocol_has_site',
      "text": "Site",
      id: 'site_id',
      "type": "autocomplete",
      "table": {
        "sortable": true,
        filter: true
      },
      "title": "site.name",
      subtitle: item => `${item.site.city} - ${item.site.code}`,
      deps: ['protocol_id'],
      readonly: item => !item.protocol_id,
      filter: (item, search) => {
        if (!search) {
          return  { protocol_id: item.protocol_id }
        }
        return { 'site.name': [{ 'site.name': `%${search}%`},
        {'site.city': `%${search}%`}, {'site.code': `%${search}%`}], protocol_id: item.protocol_id }
      },
      visible: (item, state) => state.user.role === 'Administrator' || state.user.role === 'EMN User',
      validators: [(field, value, item) => {
        return [item.storage_id, item.site_id, item.disposal_id].filter(x => !!x).length === 1 || 'Choose a Site or a Provider or a Storage'
      }]      
    },    
    {
      "value": "storage_id",
      reference: 'drug',
      id: 'storage_id',
      text: 'Storage',
      "title": "storage.name",
      subtitle: 'storage.city',
      type: 'autocomplete',
      deps: ['protocol_id'],
      filter: item => ({ protocol_id: item.protocol_id, 'storage.name': '>""' }),
      readonly: item => !item.protocol_id,
      visible: (item, state) => state.user.role === 'Administrator' || state.user.role === 'EMN User',
    },
    {
      "value": "disposal_id",
      reference: 'drug',
      id: 'disposal_id',
      text: 'Disposal',
      "title": "disposal.name",
      subtitle: 'disposal.city',
      type: 'autocomplete',
      deps: ['protocol_id'],
      filter: item => ({ protocol_id: item.protocol_id, 'disposal.name': '>""' }),
      readonly: item => !item.protocol_id,
      visible: (item, state) => state.user.role === 'Administrator' || state.user.role === 'EMN User',
    },
    {
      "value": "_site_id2",
      reference: 'monitor',
      "text": "Site",
      id: 'site_id',
      "type": "autocomplete",
      "table": {
        "sortable": true,
        filter: true
      },
      "title": "site.name",
      subtitle: item => `${item.site.city} - ${item.site.code}`,
      deps: ['protocol_id'],
      readonly: item => !item.protocol_id,
      filter: (item, search) => {
        if (!search) {
          return  { protocol_id: item.protocol_id }
        }
        return { 'site.name': [{ 'site.name': `%${search}%`},
        {'site.city': `%${search}%`}, {'site.code': `%${search}%`}], protocol_id: item.protocol_id }
      },            
      visible: (item, state) => state.user.role === 'Monitor',
    },
    {
      value: 'destroy_expired',
      type: 'check',
      text: 'ATTENTION: I want to destroy NOT EXPIRED or EXPIRING drugs',
      visible: (item, state) => state.user.role !== 'Administrator' && state.user.role !== 'EMN User',
    },
    {
      value: "site_id",
      deps: ['_site_id1', '_site_id2'],
      default: item => item._site_id1 ?? item._site_id2,
      type: 'hidden'
    },
    {
      full: true,
      value: 'note',
      text: 'Reasons for destruction',
      type: 'textarea',
      validators: ['required']
    },    
    {
      text: 'Request Date',
      value: 'request_date',
      type: 'hidden',
      table: true,
    },
    {
      text: 'Status',
      value: 'status',
      type: 'list',
      table: true,
      visible: false
    }
  ],
}
